/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  appname: 'Pistologia',
  urlbase: (() => { if (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && !window.location.hostname.includes('entregadigital.app.br')) { let p = window.location.hostname.split('.'); p[0] = 'api-edm'; return 'https://' + p.join('.') + '/api/v1/pwa/'; } return 'https://api-pistologia.entregadigital.app.br/api/v1/pwa/'; })(),

  ds: '&dM4_', // Descryptor Hash

  oneSignalAppID: '',
  oneSignalSafariWebID: '',
  subdomainName: '',




  version:'1.0.8',
  disableDevToolsDetector: false,
};
